var _circle, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsersGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 31.8001,
    r: 14.1333,
    stroke: "#001F55",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.2 42.4001C79.0542 42.4001 83.8 38.4452 83.8 33.5667C83.8 28.6882 79.0542 24.7334 73.2 24.7334",
    stroke: "#001F55",
    strokeOpacity: 0.5,
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8 42.4001C26.9458 42.4001 22.2 38.4452 22.2 33.5667C22.2 28.6882 26.9458 24.7334 32.8 24.7334",
    stroke: "#001F55",
    strokeOpacity: 0.5,
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3639 63.6001C73.1677 65.6789 74.2 68.0925 74.2 70.6668C74.2 78.4724 64.7085 84.8001 53 84.8001C41.2916 84.8001 31.8 78.4724 31.8 70.6668C31.8 62.8612 41.2916 56.5334 53 56.5334C54.2039 56.5334 55.3843 56.6003 56.5334 56.7289",
    stroke: "#001F55",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2666 77.7333C86.4649 76.3741 90.8666 72.9317 90.8666 68.9C90.8666 64.8682 86.4649 61.4259 80.2666 60.0667",
    stroke: "#001F55",
    strokeOpacity: 0.5,
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7334 77.7333C19.5351 76.3741 15.1334 72.9317 15.1334 68.9C15.1334 64.8682 19.5351 61.4259 25.7334 60.0667",
    stroke: "#001F55",
    strokeOpacity: 0.5,
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersGroup);
export default __webpack_public_path__ + "static/media/UsersGroup.167dbb30b205a769e9034950ae03eef2.svg";
export { ForwardRef as ReactComponent };